import { BookLink, Chapter, Reveal } from "./booking";

const TRAITS = ["Skilled Barbers", "Precision Cuts", "Fresh Fades", "Beard Grooming", "Walk-Ins & Appointments"];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="px-5 lg:px-12 py-20 lg:py-32">
      <Chapter index="01" title="The Shop" />
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-6">
          <Reveal>
            <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
              A modern barbershop.
              <br />
              <span className="text-primary">A Springfield staple.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base sm:text-lg leading-relaxed text-muted-foreground font-light max-w-xl">
              Faded Barber Co. is located in Springfield, VA and provides precision cuts, fresh
              fades, beard grooming, and professional barber services in a modern, clean
              environment. Premium grooming, affordable pricing, and barbers who take every detail
              seriously.
            </p>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-muted-foreground font-light max-w-xl">
              Conveniently located in Springfield, VA, Faded Barber Co. serves clients throughout
              Springfield, Alexandria, and surrounding Northern Virginia communities.
            </p>
          </Reveal>
          <Reveal delay={0.25} className="mt-8 flex flex-wrap gap-2">
            {TRAITS.map((t) => (
              <span
                key={t}
                className="font-mono text-[11px] tracking-[0.2em] uppercase border border-border px-4 py-2 text-foreground/70"
              >
                {t}
              </span>
            ))}
          </Reveal>
          <Reveal delay={0.35} className="mt-10">
            <BookLink testid="about-book-button" className="btn-primary">
              Book Your Chair
            </BookLink>
          </Reveal>
        </div>
        <div className="lg:col-span-6 grid grid-cols-2 gap-4">
          <Reveal delay={0.1} className="overflow-hidden group col-span-2">
            <img
              src="/images/kids.jpg"
              alt="Faded Barber Co. barber with two smiling young clients after fresh cuts"
              loading="lazy"
              className="w-full aspect-[16/10] object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </Reveal>
          <Reveal delay={0.2} className="overflow-hidden group">
            <img
              src="/images/fade-closeup.jpg"
              alt="Close-up of a Faded Barber Co. barber blending a skin fade with clippers"
              loading="lazy"
              className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </Reveal>
          <Reveal delay={0.3} className="overflow-hidden group">
            <img
              src="/images/wall-logo.jpg"
              alt="Faded Barber Co. logo wall sign inside the Springfield barbershop"
              loading="lazy"
              className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
